// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Interface_97f6a1', '__Interface_Fallback_97f6a1'"},"className":"__className_97f6a1","variable":"__variable_97f6a1"};